// extracted by mini-css-extract-plugin
export var date_container = "index-module--date_container--9b7af";
export var date_tag_container = "index-module--date_tag_container--6b7e6";
export var news_item_container = "index-module--news_item_container--b800f";
export var news_link = "index-module--news_link--b8de4";
export var title_arrow_container = "index-module--title_arrow_container--2d803";